import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

/**
 * EditDriverPage redirects to the CreateDriverWizardPage in edit mode.
 * All driver editing is handled by the wizard with ?driverId= param.
 */
const EditDriverPage: React.FC = () => {
    const navigate = useNavigate();
    const { driverId } = useParams<{ driverId: string }>();

    useEffect(() => {
        if (driverId) {
            navigate(`/admin/drivers/create?step=personal&driverId=${driverId}`, { replace: true });
        } else {
            navigate('/admin/drivers', { replace: true });
        }
    }, [driverId, navigate]);

    return (
        <div className="flex items-center justify-center min-h-[400px]">
            <Loader2 className="w-8 h-8 animate-spin text-primary" />
        </div>
    );
};

export default EditDriverPage;
